import React from 'react';
import { Link } from 'react-router-dom';

export function displayList(recipes) {
    return (
        <>
            {recipes && recipes.map((recipe, index) => (
                <div key={index} className="recipe-card card mb-3">
                    <div className="row g-0 align-items-stretch">
                        {/* Image on the right for md+, on top for mobile */}
                        <div className="col-md-8 d-flex flex-column">
                            <div className="card-body flex-grow-1">
                                <h5 className="recipe-card-title">
                                    <Link to={`/categories/${recipe.category_id}/recipes/${recipe.id}`}>
                                        {recipe.name}
                                    </Link>
                                </h5>
                                <div className="recipe-card-meta">
                                    <span>Source: {recipe.source || "Unknown"}</span><br />
                                    <span>
                                        Submitted by: <Link to={`/users/${recipe.username}`}>
                                            {recipe.username || "Unknown"}
                                        </Link>
                                    </span><br />
                                    <span>Last updated: {recipe.last_updated || "Unknown"}</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4">
                            {recipe.food_image ?
                                <img
                                    src={recipe.food_image || "/images/placeholder.jpg"}
                                    alt={recipe.name}
                                    className="recipe-card-img img-fluid"
                                />
                                :
                                <>&nbsp;</>
                            }
                        </div>
                    </div>
                </div>
            ))
            }
        </>
    )
}